import { useQuery } from '@tanstack/vue-query'
import request from '@/core/request'
import { empty } from './const'
import { useRoute } from 'vue-router'
import dayjs from 'dayjs'
import { watch } from 'vue'
import merge from 'lodash/merge'

export const emptyUserInfo: empty = {
  rank: 0,
  score: '0', // 积分
  score_diff: '0', // 与上一名积分差距
  score_rank_diff: '0', // 距离上榜的分差
  user1: {
    user_id: 0,
    nickname: '虚位以待',
    avatar_url: 'rank-icon-empty',
    public_id: '',
  },
  user2: {
    user_id: 0,
    nickname: '虚位以待',
    avatar_url: 'rank-icon-empty',
    public_id: '',
  },
}

export const autoFillEmpty = (arr: any[], emptyUserInfo: any, length: number) => {
  // 不修改传入的原数组，避免对只读数据进行写操作
  const result = Array.isArray(arr) ? arr.slice() : []
  while (result.length < length) {
    result.push(emptyUserInfo)
  }
  return result.map(i => {
    return {
      ...merge({}, emptyUserInfo, i),
    }
  })
}

import { computed, ref } from 'vue'
import { H5JumpApp } from '@/core/bridge'
import { getRandomRoomId } from '@/service/newindex'
import { RoomLink } from '@/state/const'
import client from '@/utils/client'

const handleClick = async (props: any) => {
  const res = await getRandomRoomId()
  if (res.data?.room_id) {
    const roomId = res.data.room_id
    if (props.tabId && props.giftId) {
      H5JumpApp(RoomLink + roomId + `&giftTabId=${props.tabId}&giftId=${props.giftId}`)
    } else if (props.tabId) {
      H5JumpApp(RoomLink + roomId + `&giftTabId=${props.tabId}`)
    } else {
      H5JumpApp(RoomLink + roomId)
    }
  } else if (res.msg) {
    client.toast(res.msg)
  }
}

import { trackEvent } from '@/utils/tracking_utils'
import { user } from '@/state/user'

// 根据vue文件中的rankTab请求不同的榜单类型
export const useRank = (uiMeta: any, payload: any) => {
  const route = useRoute()
  const activity_code = route.meta?.activity_code
  const componentId = uiMeta.config?.componentId
  const rankType = ref(0)
  const handleRankType = (type: number) => {
    rankType.value = type
    refetch()
  }

  const handleAvatarClick = (userId: number) => {
    // 送礼人榜单不让跳转，怕骚扰榜1大哥
    if (rankType.value === 0) {
      return
    }

    const allUrlParams = new URLSearchParams(window.location.search)
    const publicId = allUrlParams.get('public_id')
    const deviceId = allUrlParams.get('device_id')
    if (userId) {
      H5JumpApp('user_home', { user_id: String(userId) })
      trackEvent(user, 'click_to_user_profile', {
        app_user_id: publicId,
        app_device_id: deviceId,
      })
    }
  }

  const { data, isLoading, refetch, isRefetching } = useQuery({
    queryKey: ['rank', componentId, rankType.value, activity_code],
    queryFn: () =>
      request.get(uiMeta.config.api, {
        ...payload,
        activity_code,
        component_id: componentId,
        rank_date: route.query.rank_date || dayjs().format('YYYY-MM-DD'),
      }),
  })

  watch(
    () => route.query.rank_date,
    newVal => {
      console.log('rank_date', newVal)
      uiMeta.config?.isDayRank && refetch()
    },
    {
      immediate: true,
      deep: true,
    }
  )

  const list = computed(() => autoFillEmpty(data.value?.data?.list || [], emptyUserInfo, uiMeta.config.length))
  const mine = computed(() => {
    const source = data.value?.data?.mine_rank
    const mineBtnBg =
      source?.rank === 1
        ? uiMeta.images.keepBtn
        : source?.rank <= uiMeta.config.length && source?.rank > 1
          ? uiMeta.images.impactBtn
          : uiMeta.images.noRank
    return {
      ...data.value?.data?.mine_rank,
      bg: uiMeta.images.fixedBg,
      avatarPosition: uiMeta.layout.mineConfig.avatarPosition,
      nicknamePosition: uiMeta.layout.mineConfig.nicknamePosition,
      unitPosition: uiMeta.layout.mineConfig.unitPosition,
      scorePosition: uiMeta.layout.mineConfig.scorePosition,
      rankPosition: uiMeta.layout.mineConfig.rankPosition,
      mineBtnBg,
      mineBtnPosition: uiMeta.layout.mineConfig.mineBtnPosition,
      isInRank: data.value?.data?.mine_rank?.rank !== -1 && data.value?.data?.mine_rank?.rank <= uiMeta.config.length,
      scoreType: uiMeta.config.scoreType,
    }
  })
  const top3 = computed(() => {
    const copyList = list.value.slice(0)
    return copyList.slice(0, 3).map((item: any, index: number) => ({
      ...item,
      bg: uiMeta.images[`top${index + 1}Bg` as keyof typeof uiMeta.images],
      avatar_url: item.user?.avatar_url
        ? item.user.avatar_url
        : uiMeta.images[`top${index + 1}Empty` as keyof typeof uiMeta.images],
      unit: uiMeta.config.units[rankType.value],
      avatarPosition: uiMeta?.layout?.top3Config?.avatarPosition,
      nicknamePosition: uiMeta.layout.top3Config.nicknamePosition,
      unitPosition: uiMeta?.layout?.top3Config?.unitPosition,
      scorePosition: uiMeta?.layout?.top3Config?.scorePosition,
      rankPosition: uiMeta?.layout?.top3Config?.rankPosition,
      scoreType: uiMeta.config.scoreType,
    }))
  })
  const listother = computed(() => {
    const copyList = list.value.slice(0)
    return copyList.slice(3, uiMeta.config.length).map((item: any, index: number) => ({
      ...item,
      bg: uiMeta.images.commonBg,
      avatar_url: item.user?.avatar_url ? item.user.avatar_url : uiMeta.images[`commonEmpty` as keyof typeof uiMeta.images],
      unit: uiMeta.config.units[rankType.value],
      avatarPosition: uiMeta?.layout?.commonConfig?.avatarPosition,
      nicknamePosition: uiMeta.layout.commonConfig.nicknamePosition,
      unitPosition: uiMeta?.layout?.commonConfig?.unitPosition,
      scorePosition: uiMeta?.layout?.commonConfig?.scorePosition,
      rankPosition: uiMeta?.layout?.commonConfig?.rankPosition,
      scoreType: uiMeta.config.scoreType,
    }))
  })

  return {
    list,
    mine,
    top3,
    listother,
    isLoading,
    isRefetching,
    uiMeta,
    rankType,
    handleRankType,
    handleClick,
    handleAvatarClick,
    refetch,
  }
}
